/**
 * Catálogos de pago del flujo. Viven aquí y no en una vista porque el paso 2 y
 * la revisión editable del paso 3 muestran los mismos valores: con una copia en
 * cada pantalla, agregar una forma de pago la deja visible en una sola.
 */
export const PAYMENT_FORMS: Record<string, string> = {
  '01': 'Efectivo',
  '02': 'Cheque nominativo',
  '03': 'Transferencia electrónica de fondos',
  '04': 'Tarjeta de crédito',
  '28': 'Tarjeta de débito',
  '99': 'Por definir',
};

export const CURRENCIES = [
  { code: 'MXN', name: 'Pesos' },
  { code: 'USD', name: 'Dólares' },
  { code: 'EUR', name: 'Euros' },
] as const;

/** Singular de cada moneda extranjera, para «pesos por cada dólar». */
export const CURRENCY_UNIT: Record<string, string> = {
  USD: 'dólar',
  EUR: 'euro',
};

/** El mismo catálogo como lista, que es lo que consumen los selectores. */
export const PAYMENT_FORM_OPTIONS = Object.entries(PAYMENT_FORMS).map(([code, name]) => ({
  code,
  name,
}));

/** PUE = una sola exhibición · PPD = en parcialidades. */
export const PAYMENT_METHODS = [
  { code: 'PUE', name: 'Es un solo pago' },
  { code: 'PPD', name: 'Pago en parcialidades' },
] as const;
